import React from 'react';
import SubmissionViewer from '../../components/admin/SubmissionViewer';

const ContactMessages = () => {
  const columns = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'company', label: 'Company', type: 'text' },
    { key: 'message', label: 'Message', type: 'long-text' },
  ];

  return (
    <SubmissionViewer 
      tableName="contact_messages" 
      title="All Contact Messages" 
      columns={columns} 
    />
  );
};

export default ContactMessages;
